//
//
//
//
//
//
//
//
//


import debounce from 'lodash/debounce';
import Bowser from 'bowser';

export default {

    async mounted() {
        this.resizeListener = debounce(() => {
            this.$store.dispatch('ui/setIsPortraitMode');
        }, 200);
        window.addEventListener('resize', this.resizeListener);
        window.addEventListener('orientationchange', this.resizeListener);

        const browser = Bowser.getParser(window.navigator.userAgent);
        const isLegacyBrowser = browser.satisfies({
            'internet explorer': '<=11',
        });
        this.$store.commit('setIsLegacyBrowser', isLegacyBrowser);

        await Promise.all([
            this.$store.dispatch('apidata/loadResortData'),
            this.$store.dispatch('apidata/loadWeatherStationData'),
            this.$store.dispatch('ui/setIsPortraitMode'),
            this.$store.dispatch('checkWebP'),
        ]);

        if (!this.$store.state.apidata.resortDataError && !this.$store.state.apidata.weatherStationDataError) {
            this.$store.commit('apidata/setIsDataReady', true);
        } else {
            this.$store.commit('setFatalError', this.$t('errors.loading'));
            if (this.$store.state.apidata.resortDataError) {
                this.$bugsnag.notify(new Error(`Map web view: Error loading resort data: ${this.$store.state.apidata.resortDataError}`));
            }
            if (this.$store.state.apidata.weatherStationDataError) {
                this.$bugsnag.notify(new Error(`Map web view: Error loading weather station data: ${this.$store.state.apidata.weatherStationDataError}`));
            }
        }
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.resizeListener);
        window.removeEventListener('orientationchange', this.resizeListener);
    },

};
